import React from "react";
import About from "../components/about";

const AboutPage = () => (
  <div className="pt-20">
    <About />
  </div>
);

export default AboutPage;
